class RequestBuilder {
  constructor() {
    // pass
  }
  getHeaders() {
    // Portal auth uses HttpOnly cookies — no Authorization header needed.
    // Cookies are sent automatically via credentials: 'include'.
    return new Headers({'Content-Type': 'application/json'}); // eslint-disable-line no-undef
  }
  async getRiskMapsRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/maps`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getWeatherMapsRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/weathermaps`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getRiskDataRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/riskdata`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getPersonalizeRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/personalize`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getConfigureRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/config`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getBaseMapConfigureRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/baseMaps`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getConfigureParametersRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/parameterconfig`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getFeaturesRequest(serverRoute) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/features`); // eslint-disable-line no-undef
    return [request, options];
  }
  async weatherModelRequest(serverRoute, region, site, hazard, parameter) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      credentials: 'include',
      headers: headers
    };
    const request = new Request(`${serverRoute}/wxdata?region=${region}&site=${site}&hazard=${hazard}&parameter=${parameter}`); // eslint-disable-line no-undef
    return [request, options];
  }
  async weatherObservationRequest(serverRoute, latitude, longitude, parameter, radius) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      credentials: 'include',
      headers: headers
    };
    const request = new Request(`${serverRoute}/weatherobs?latitude=${latitude}&longitude=${longitude}&parameter=${parameter}&radius=${radius}`); // eslint-disable-line no-undef
    return [request, options];
  }
  async saveConfigRequest(serverRoute, config) {
    const headers = this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify(config)
    };
    const request = new Request(`${serverRoute}/config`); // eslint-disable-line no-undef
    return [request, options];
  }
  async publishPreferencesRequest(serverRoute, preferences) {
    const headers = this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify(preferences)
    };
    const request = new Request(`${serverRoute}/preferences`); // eslint-disable-line no-undef
    return [request, options];
  }
  async getFeature(serverRoute, featureId, featureName = null) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    let requestUrl = `${serverRoute}/getFeatureResource?id=${featureId}`
    if (featureName != null) {
      requestUrl += `&featureName=${featureName}`
    }
    const request = new Request(requestUrl); // eslint-disable-line no-undef
    return [request, options];
  }
  async getTzRequest(serverRoute, latitude, longitude) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/tz?latitude=${latitude}&longitude=${longitude}`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getMultipleFeatures(serverRoute, featureId) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/getMultipleFeatureResources?id=${featureId}`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getFeatureLayerInfo(serverRoute, featureId, layerParams) {
    const headers = this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/getFeatureLayerInfo${layerParams}&id=${featureId}`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getOfficeDetailsByCodesRequest(serverRoute, officeCodes) {
    const headers = await this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify(officeCodes)
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/Locations/by-codes`); // eslint-disable-line no-undef
    return [request, options];
  }

  async createMessageRequest(serverRoute, messageData) {
    const headers = await this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify(messageData)
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/messages`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getCrisisTypes(serverRoute) {
    const headers = await this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      cache: 'default',
      credentials: "include"
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/CrisisTypes?activeOnly=true`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getMessageTypes(serverRoute) {
    const headers = await this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/MessageTypes`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getSchedulingRules(serverRoute) {
    const headers = await this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/SchedulingRules`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getEvents(serverRoute) {
    const headers = await this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/Events?activeOnly=true`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getTemplatesByCrisisType(serverRoute, crisisTypeId) {
    const headers = await this.getHeaders();
    const options = {
      method: 'GET',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default'
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/Templates/crisis-type/${encodeURIComponent(crisisTypeId)}`); // eslint-disable-line no-undef
    return [request, options];
  }

  async getContactsByLocations(serverRoute, locationIds) {
    const headers = await this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify(locationIds)
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/Contacts/by-locations`); // eslint-disable-line no-undef
    return [request, options];
  }

  async sendMessageRequest(serverRoute, messageId, contactIds) {
    const headers = await this.getHeaders();
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify({ contactIds: contactIds })
    };
    const request = new Request(`${serverRoute}/mct-proxy/api/Messages/${messageId}/send`); // eslint-disable-line no-undef
    return [request, options];
  }

  async submitMessageReply(mctServerRoute, token, response, comment = null) {
    const headers = {
      'Content-Type': 'application/json'
    };
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify({
        token: token,
        response: response,
        comment: comment
      })
    };
    const request = new Request(`${mctServerRoute}/api/Messages/reply`); // eslint-disable-line no-undef
    return [request, options];
  }

  async updateContactLanguage(mctServerRoute, token, languageCode) {
    const headers = {
      'Content-Type': 'application/json'
    };
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      credentials: 'include',
      cache: 'default',
      body: JSON.stringify({
        token: token,
        preferredLanguageCode: languageCode
      })
    };
    const request = new Request(`${mctServerRoute}/api/contacts/update-language`); // eslint-disable-line no-undef
    return [request, options];
  }
}

export default RequestBuilder;

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = RequestBuilder;
  module.exports.default = RequestBuilder;
}
